import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { MutationService, QueryService } from '@ngneat/query';
import { ThemeRepository } from 'src/app/_core';
import { ContactDto } from './home.type';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class HomeService {
  private readonly _httpClient = inject(HttpClient);
  private readonly _queryService = inject(QueryService);
  private readonly _mutationService = inject(MutationService);
  private readonly _themeRepository = inject(ThemeRepository);

  getHomepageData(locale: string, draft?: boolean, token?: string) {
    return this._queryService.use(
      [`homepage${draft ? '-draft' : ''}`, locale],
      () => {
        return this._httpClient.get<any>(
          `/api/globals/homepage?locale=${locale}&draft=${draft}&token=${token}`
        );
      }
    );
  }

  getFooterData(locale: string, draft?: boolean) {
    return this._queryService.use(['footer', locale], () => {
      return this._httpClient.get<any>(
        `/api/globals/footer?locale=${locale}&draft=${draft}`
      );
    });
  }

  sendEmail() {
    return this._mutationService.use((data: ContactDto) => {
      return this._httpClient.post(
        `${environment.apiUrl}/public/email/send-contact`,
        data
      );
    });
  }
}
